import { DodoProductType, DodoServiceType } from "./shopping-cart.models";
import { DodoProduct } from "app/plan/plan.models";

export class ProductInfo {
	title: string;
	features?: string[];
	info?: string;
}

export class DodoCartProduct {
	type: DodoProductType;
	icon: string;
	name: string;
	productInfo?: ProductInfo;
	product?: DodoProduct;

	private __nameMap = {
		"internet-nbn": "Internet",
		"internet-adsl": "Internet",
		electricity: "Electricity",
		gas: "Gas",
		mobile: "Mobile"
	};

	private __iconMap = {
		"internet-nbn": "internet",
		"internet-adsl": "internet",
		electricity: "electricity",
		gas: "gas",
		mobile: "mobile"
	};

	constructor(type: DodoProductType) {
		this.type = type;
		this.icon = this.__iconMap[this.type];
		this.name = this.__nameMap[this.type];
	}

	static ToService(productType: DodoProductType): DodoServiceType {
		switch (productType) {
			case "internet-nbn":
			case "internet-adsl":
			case "internet-op-nbn":
				return "internet";
			case "mobile":
				return "mobile";
			case "electricity":
			case "gas":
			case "electricity-and-gas":
				return "energy";
			default:
				return undefined;
		}
	}
}
